var exports = {
  "x6": "x234b8571--216c39--button",
  "jH": "x234b8571--216c39--button-left",
  "C9": "x234b8571--216c39--button-right",
};

module.exports = exports;
